import { createGtm } from '@gtm-support/vue-gtm'

export default async ({ app, router }) => {
  if (process.env.GTM) {
    app.use(
      createGtm({
        id: process.env.GTM,
        compatibility: true,
        defer: true,
        enabled: true,
        debug: false,
        loadScript: true,
        vueRouter: router,
        trackOnNextTick: true,
      })
    )
  }
}
